import { get } from 'lodash';
import React, { useContext } from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

import styled from '@emotion/styled';
import ColorPicker from 'rc-color-picker';
import Popover from '~/App/Components/Popover';
import { computeTextColor } from '~/utils/Color';
import { debounce } from 'lodash';

import EditorContext, { EditorContextProps } from '../Pages/Editor/Context';

const ColorPickerPanel = styled(ColorPicker.Panel)`
  margin-bottom: 10px;
`;

const ColorPickerContainer = styled.div`
  position: relative;
`;

const ColorPreview = styled.button`
  border: none;
  display: block;
  border-radius: 50%;
  position: absolute;
  right: 15px;
  width: 20px;
  height: 20px;
  background-color: ${({ color }: { color: string }) => color};
  top: 50%;
  transform: translateY(-50%);
`;

interface ColorPickerBodyProps {
  onChange: ({ color }: { color: string }) => void;
  defaultColor: string;
}

function ColorPickerBody({ onChange, defaultColor }: ColorPickerBodyProps) {
  return (
    <ColorPickerPanel
      onChange={onChange}
      enableAlpha={false}
      defaultColor={defaultColor}
    />
  );
}

interface Theme {
  primary_color: string;
  secondary_color: string;
}

interface ColorPickerPopoverProps {
  isOpen: boolean;
  setOpen: (val: boolean) => void;
}

export default function ColorPickerPopover({
  isOpen,
  setOpen,
}: ColorPickerPopoverProps) {
  const context: EditorContextProps = useContext(EditorContext);
  const onChangeColor = debounce(({ color }) => {
    context.set<Theme>('theme', {
      primary_color: color,
      secondary_color: computeTextColor(color),
    });
  }, 250);

  const defaultColor: string = context.get<string>(['theme', 'primary_color']);

  const popOverProps = {
    preferPlace: 'below',
    align: 'right',
    isOpen,
    body: ColorPickerBody({ onChange: onChangeColor, defaultColor }),
    onOuterAction: () => setOpen(false),
    style: { zIndex: 9999 },
  };

  return (
    <FormGroup>
      <ControlLabel>Button Color</ControlLabel>
      <Popover {...popOverProps}>
        <ColorPickerContainer>
          <ColorPreview onClick={() => setOpen(true)} color={defaultColor} />
          <FormControl
            style={{ backgroundColor: 'unset' }}
            value={defaultColor}
            placeholder={get(window, 'Bonjoro.messageTemplate.defaultCtaUrl')}
            onFocus={() => setOpen(true)}
            readOnly={true}
          />
        </ColorPickerContainer>
      </Popover>
    </FormGroup>
  );
}
